import { toast } from 'react-toastify';
import { all, put, takeLatest } from 'redux-saga/effects';
import * as service from '../../services/menu.service';
import {
    getCategoryRequest,
    getCategorySucess,
    getMenuItemsRequest,
    getMenuItemsSuccess,
    setMenuModalData
} from '../slice';
import {
    CREATE_CATEGORY_REQUEST,
    CREATE_MENU_ITEM_REQUEST,
    GET_CATEGORY_REQUEST,
    GET_MENU_ITEMS_REQUEST,
    REMOVE_CATEGORY_REQUEST,
    REMOVE_MENU_ITEM_REQUEST,
    UPDATE_CATEGORY_REQUEST,
    UPDATE_MENU_ITEM_REQUEST
} from '../types';

function* getCategoryRequestSaga(action) {
    try {
        const hotelId = action.payload;
        const res = yield service.getCategories(hotelId);
        yield put(getCategorySucess(res));
    } catch (error) {
        console.error('Failed to fetch categories ', error);
        toast.error(`Failed to fetch categories ${error.message}`);
    }
}

function* createCategoryRequestSaga(action) {
    try {
        const payload = action.payload;
        const data = new FormData();
        data.append(`hotelId`, payload.hotelId);
        payload.data.forEach((item, index) => {
            data.append(`data[${index}][name]`, item.name);
            data.append(`data[${index}][order]`, item.order);
            data.append(`data[${index}][imageUrl]`, item.imageUrl);
            data.append(`data[${index}][filename]`, (item.file?.name || ''));

            if (item.file) data.append('file', item.file);
        });
        yield service.createCategories(data);
        toast.success('Category added successfully');

        yield put(setMenuModalData('SUCCESS'));
        yield put(getCategoryRequest(payload.hotelId));
    } catch (error) {
        toast.error(`Failed to create category ${error.message}`);
        yield put(setMenuModalData(false));
    }
}

function* updateCategoryRequestSaga(action) {
    try {
        const { categoryId, data, hotelId } = action.payload;
        const payload = new FormData();
        payload.append(`hotelId`, hotelId);
        Object.keys(data).forEach((item) => {
            if (item === 'file') {
                payload.append('file', data[item]);
                payload.append('data[filename]', data[item]?.name || '');
            } else {
                payload.append(`data[${item}]`, data[item]);
            }
        });

        yield service.updateCategory(categoryId, payload);
        toast.success('Category details updated successfully');

        yield put(setMenuModalData('SUCCESS'));
        yield put(getCategoryRequest(hotelId));
    } catch (error) {
        toast.error(`Failed to update category ${error.message}`);
        yield put(setMenuModalData(false));
    }
}

function* removeCategoryRequestSaga(action) {
    try {
        const { itemIds: categoryIds, hotelId } = action.payload;

        yield service.removeCategories({ categoryIds });
        toast.success('Eligible categories removed successfully');

        yield put(setMenuModalData('SUCCESS'));
        yield put(getCategoryRequest(hotelId));
    } catch (error) {
        toast.error(`Failed to remove categories ${error.message}`);
        yield put(setMenuModalData(false));
    }
}

function* getMenuItemsRequestSaga(action) {
    try {
        const res = yield service.fetchMenuItems(action.payload);
        yield put(getMenuItemsSuccess(res));
    } catch (error) {
        toast.error(`Failed to fetch menu items ${error.message}`);
    }
}

function* createMenuItemRequestSaga(action) {
    try {
        const payload = action.payload;
        const data = new FormData();
        data.append(`hotelId`, payload.hotelId);
        data.append(`categoryId`, payload.categoryId);
        payload.data.forEach((item, index) => {
            data.append(`data[${index}][name]`, item.name);
            data.append(`data[${index}][price]`, item.price);
            data.append(`data[${index}][order]`, item.order);
            data.append(`data[${index}][imageUrl]`, item.imageUrl);
            data.append(`data[${index}][filename]`, (item.file?.name || ''));
            item.subCategory.forEach((subCategoryValue) => {
                data.append(`data[${index}][subCategory][]`, subCategoryValue);
            });

            if (item.file) data.append('file', item.file);
        });

        yield service.saveMenuItems(data);
        toast.success('Menu items create successfully');

        yield put(setMenuModalData('SUCCESS'));
        yield put(getMenuItemsRequest({ categoryId: payload.categoryId }));
    } catch (error) {
        toast.error(`Failed to store menu items ${error.message}`);
        yield put(setMenuModalData(false));
    }
}

function* removeMenuItemRequestSaga(action) {
    try {
        const { itemIds: menuIds, categoryId } = action.payload;

        yield service.removeMenuItems({ menuIds });
        toast.success('Eligible menu Items removed successfully');

        yield put(setMenuModalData('SUCCESS'));
        yield put(getMenuItemsRequest({ categoryId }));
    } catch (error) {
        toast.error(`Failed to remove menu items ${error.message}`);
        yield put(setMenuModalData(false));
    }
}

function* updateMenuItemRequestSaga(action) {
    try {
        const { categoryId, id, data, hotelId } = action.payload;
        const payload = new FormData();
        payload.append(`hotelId`, hotelId);
        payload.append(`categoryId`, categoryId);
        Object.keys(data).forEach((item) => {
            if (item === 'file') {
                payload.append('file', data[item]);
                payload.append('data[filename]', data[item]?.name || '');
            } else if (item === 'subCategory') {
                payload.append(`data[${item}]`, JSON.stringify(data[item]));
            } else {
                payload.append(`data[${item}]`, data[item]);
            }
        });

        yield service.updateMenuItem(id, payload);
        toast.success('Menu item updated successfully');

        yield put(setMenuModalData('SUCCESS'));
        yield put(getMenuItemsRequest({ categoryId }));
    } catch (error) {
        toast.error(`Failed to update menu item: ${error.message}`);
        yield put(setMenuModalData(false));
    }
}

export default function* menuSaga() {
    yield all([takeLatest(GET_CATEGORY_REQUEST, getCategoryRequestSaga)]);
    yield all([takeLatest(CREATE_CATEGORY_REQUEST, createCategoryRequestSaga)]);
    yield all([takeLatest(UPDATE_CATEGORY_REQUEST, updateCategoryRequestSaga)]);
    yield all([takeLatest(REMOVE_CATEGORY_REQUEST, removeCategoryRequestSaga)]);
    yield all([takeLatest(GET_MENU_ITEMS_REQUEST, getMenuItemsRequestSaga)]);
    yield all([takeLatest(CREATE_MENU_ITEM_REQUEST, createMenuItemRequestSaga)]);
    yield all([takeLatest(REMOVE_MENU_ITEM_REQUEST, removeMenuItemRequestSaga)]);
    yield all([takeLatest(UPDATE_MENU_ITEM_REQUEST, updateMenuItemRequestSaga)]);
}
